export const LOAD_MORE_HANDLING_OPTION = 'loadMore';

export const MOBILE_FILTERS_APPLY_HANDLING_OPTION = 'mobileFiltersApply';

export const MOBILE_FILTERS_SHOW_RESULTS = 'mobileFilterShowResults';

export const FAMILY_FILTERS_REQUEST = 'familyFiltersRequest';

export const DEFAULT_HANDLING_OPTION = '';
